<template>
  <Swiper
    wrapper-class="homepage-wrapper"
    :settings="swiperSettings"
    :class="{ 'rounded-t-md overflow-hidden homepage-slider': !isMobile, 'homepage-mobile-slider w-full': isMobile }"
    :style="{ width: !isMobile && '530px' }"
    :modules="[Navigation]"
    @swiper="onSwiper"
  >
    <template v-for="(item, i) in items">
      <div
        v-if="$supports('sliderAds') && !secondSlider && i === 7"
        id="sliderNativeAds_1"
        :key="`ad_${i}`"
        class="swiper-slide homepage-slide"
        :style="{ height: !isMobile && '415px', paddingBottom: isMobile && '78.3%' }"
      />
      <SwiperSlide
        v-if="isMobile"
        :key="item.id"
        class="w-full h-full overflow-hidden relative"
        style="padding-bottom: 78.3%"
        v-bind="bindItem"
      >
        <template v-if="item.sliderImage">
          <a :href="getArticleUrl({ article: item })" :title="item.title" class="absolute inset-0" v-bind="bindLink">
            <img
              :src="item.sliderImage.resolutions.standard.url"
              :alt="item.title"
              :loading="i === 0 ? 'eager' : 'lazy'"
              class="h-full w-full object-cover"
              v-bind="bindImage"
            />
          </a>
        </template>
        <template v-else>
          <a
            :href="getArticleUrl({ article: item })"
            class="flex flex-col items-center h-full w-full absolute inset-0"
            :title="item.sliderTitle || item.title"
            v-bind="bindLink"
          >
            <div class="w-full relative">
              <div style="padding-bottom: 56.25%"></div>
              <div class="absolute inset-0">
                <img
                  :src="item.image.resolutions.standard.url"
                  :alt="item.sliderTitle || item.title"
                  :loading="i === 0 ? 'eager' : 'lazy'"
                  class="block w-full h-full object-cover"
                  v-bind="bindImage"
                />
              </div>
            </div>
            <div class="flex-grow w-full flex items-center relative flex-shrink-0" style="background: #171717">
              <div style="padding-bottom: 7.83%"></div>
              <div style="width: 264px" class="h-[6px] flex absolute top-0 left-0">
                <div style="width: 256px" class="h-full bg-o-red"></div>
                <div class="w-0 h-0 border-r-6 border-t-6 border-r-transparent border-t-o-red" style=""></div>
              </div>
              <div class="px-4 mt-2">
                <span class="line-clamp-2 font-bold text-20 text-white" v-bind="bindTitle">
                  {{ item.sliderTitle || item.title }}
                </span>
              </div>
            </div>
          </a>
        </template>
      </SwiperSlide>
      <SwiperSlide v-else :key="item.id" class="homepage-slide" style="height: 415px" v-bind="bindItem">
        <template v-if="item.sliderImage">
          <a :href="getArticleUrl({ article: item })" :title="item.title">
            <img
              :src="item.sliderImage.resolutions.standard.url"
              :alt="item.title"
              :loading="i === 0 ? 'eager' : 'lazy'"
              v-bind="bindImage"
            />
          </a>
        </template>
        <template v-else>
          <a
            :href="getArticleUrl({ article: item })"
            class="flex flex-col items-center h-full"
            :title="item.sliderTitle || item.title"
            v-bind="bindLink"
          >
            <div class="w-full relative">
              <div style="padding-bottom: 56.25%"></div>
              <div class="absolute inset-0">
                <img
                  :src="item.image.resolutions.standard.url"
                  :alt="item.sliderTitle || item.title"
                  :loading="i === 0 ? 'eager' : 'lazy'"
                  class="block w-full h-full object-cover"
                  v-bind="bindImage"
                />
              </div>
            </div>
            <div class="flex-grow w-full flex items-center relative flex-shrink-0" style="background: #171717">
              <div style="width: 264px" class="h-2 flex absolute top-0 left-0">
                <div style="width: 256px" class="h-full bg-o-red"></div>
                <div class="w-0 h-0 border-r-8 border-t-8 border-r-transparent border-t-o-red" style=""></div>
              </div>
              <div class="px-6 mt-2">
                <span class="line-clamp-2 font-bold text-24 text-white" v-bind="bindTitle">
                  {{ item.sliderTitle || item.title }}
                </span>
              </div>
            </div>
          </a>
        </template>
      </SwiperSlide>
    </template>
    <template #container-end>
      <div v-if="isMobile" style="height: 40px" class="bg-black border-t border-white-20 flex">
        <OButton pure class="u-center text-white px-4" @click="slideChangeNavigation('prev')">
          <OIcon icon="chevron-left-white" />
        </OButton>
        <div class="flex-grow flex items-center justify-center space-x-2">
          <OButton
            v-for="index in range(secondSlider || !$supports('sliderAds') ? items.length : items.length + 1)"
            :key="`page_${index + 1}`"
            pure
            style="width: 9px; height: 9px"
            class="rounded-full bg-white transition-all"
            :class="{ 'swiper-active-pagination': swiperIndex === index }"
            @click="slideChange(index)"
          ></OButton>
        </div>
        <OButton pure class="u-center text-white px-4" @click="slideChangeNavigation('next')">
          <OIcon icon="chevron-left-white" class="rotate-180" />
        </OButton>
      </div>
      <div v-else style="height: 50px" class="bg-black border-t border-white-20 flex">
        <OButton
          pure
          style="width: 50px"
          class="h-full border-r border-white-20 u-center text-white"
          @click="slideChangeNavigation('prev')"
        >
          <OIcon icon="chevron-left-white" />
        </OButton>
        <div class="flex-grow flex items-center justify-center space-x-[5px]">
          <OButton
            v-for="index in range(secondSlider || !$supports('sliderAds') ? items.length : items.length + 1)"
            :key="`page_${index + 1}`"
            pure
            style="width: 21px; height: 21px"
            class="rounded-full u-center text-sm text-white border border-white-20 transition-none"
            :class="{ 'swiper-active-pagination': swiperIndex === index }"
            @click="slideChange(index)"
            @mouseenter="slideChange(index)"
          >
            {{ index + 1 }}
          </OButton>
        </div>
        <OButton
          pure
          style="width: 50px"
          class="h-full border-l border-white-20 u-center text-white"
          @click="slideChangeNavigation('next')"
        >
          <OIcon icon="chevron-left-white" class="rotate-180" />
        </OButton>
      </div>
    </template>
  </Swiper>
</template>

<script>
import { defineComponent, computed, ref, onMounted, useContext, useMeta } from '@nuxtjs/composition-api';
import { Navigation } from 'swiper';
import Swiper from '@/modules/sliders/core/Swiper';
import SwiperSlide from '@/modules/sliders/core/SwiperSlide';
import { useTracking } from '@/modules/tracking/composables/useTracking';
import { range, memoize } from 'lodash';
import { OButton, OIcon } from '~/modules/common/components/ui';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { bodyClassFixer } from '~/modules/common/utils/helpers';
import { useDevice } from '~/composables/useDevice';

export default defineComponent({
  props: {
    items: {
      type: Array,
    },
    secondSlider: {
      type: Boolean,
      default: false,
    },
    hp4uAttrs: {
      type: Boolean,
      default: false,
    },
  },
  components: { Swiper, SwiperSlide, OButton, OIcon },
  head: {},
  setup(props) {
    // TODO: sliderjs lib brokes body classes. this solve is experimental
    bodyClassFixer();

    const { $supports } = useContext();
    const { isMobile } = useDevice();
    const { sendDataLayer } = useTracking();
    const sliderDataLayerGeneratorFn = (item, position) => {
      let list;
      if (props.secondSlider) {
        list = 'Anasayfa - Mobile Slider';
      } else if (item.sliderImage) {
        list = 'Anasayfa - Slider - Görsel';
      } else {
        list = 'Anasayfa - Slider - Metin';
      }
      return sendDataLayer(
        {
          item,
          list,
          position,
        },
        ['init', 'initOnLoad', 'click']
      );
    };
    useMeta(() => {
      return {
        link: [
          { rel: 'preload', fetchpriority: 'high', as: 'image', href: props.items[0].image.resolutions.standard.url, type: 'image/jpeg' },
        ],
      };
    });
    const sliderDataLayerGenerator = memoize(sliderDataLayerGeneratorFn, (item, position) => `${item._id}_${position}`);
    const swiperRef = ref(null);
    const impressionTimeout = ref(null);
    const swiperSettings = {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-custom-next',
        prevEl: '.swiper-button-custom-prev',
      },
      touchEventsTarget: 'wrapper',
      speed: 100,
      preloadImages: false,
      // Click Slide Fix Try
      shortSwipes: false,
      longSwipesRatio: 0.01,
      longSwipesMs: 10,
    };

    onMounted(() => {
      const { initOnLoadEvent: dataLayerSendEvent } = sliderDataLayerGenerator(props.items[0], 1);
      dataLayerSendEvent();
    });

    const onSwiper = (swiper) => {
      swiperRef.value = swiper;
      swiper.on('slideChange', function () {
        clearTimeout(impressionTimeout.value);
        impressionTimeout.value = setTimeout(() => {
          const slideIndex = swiper.realIndex;
          if (!props.secondSlider && slideIndex !== 7 && $supports('sliderAds')) {
            const { initEvent: dataLayerSendEvent } = sliderDataLayerGenerator(
              props.items[slideIndex < 7 ? slideIndex : slideIndex - 1],
              slideIndex + 1
            );
            dataLayerSendEvent({ preventDuplicate: true });
          } else if (props.secondSlider || !$supports('sliderAds')) {
            const { initEvent: dataLayerSendEvent } = sliderDataLayerGenerator(props.items[slideIndex], slideIndex + 1);
            dataLayerSendEvent({ preventDuplicate: true });
          }
        }, 1000);
      });
      swiper.on('click', () => {
        const slideIndex = swiper.realIndex;
        if (!props.secondSlider && slideIndex !== 7 && $supports('sliderAds')) {
          sliderDataLayerGenerator(props.items[slideIndex < 7 ? slideIndex : slideIndex - 1], slideIndex + 1).clickEvent();
        } else if (props.secondSlider || !$supports('sliderAds')) {
          sliderDataLayerGenerator(props.items[slideIndex], slideIndex + 1).clickEvent();
        }
      });
    };
    const slideChange = (index) => {
      swiperRef.value?.slideToLoop(index);
    };

    const slideChangeNavigation = (direction) => {
      if (direction === 'next') {
        swiperRef.value.slideNext();
      } else {
        swiperRef.value.slidePrev();
      }
    };

    const swiperIndex = computed(() => (swiperRef.value ? swiperRef.value.realIndex : 0));

    // Taboola Hp4u Attrs
    const bindItem = props.hp4uAttrs ? { 'data-tb-region-item': '' } : {};
    const bindImage = props.hp4uAttrs ? { 'data-tb-thumbnail': '' } : {};
    const bindTitle = props.hp4uAttrs ? { 'data-tb-title': '' } : {};
    const bindLink = props.hp4uAttrs ? { 'data-tb-link': '' } : {};

    return {
      swiperSettings,
      getArticleUrl,
      onSwiper,
      swiperIndex,
      slideChange,
      slideChangeNavigation,
      Navigation,
      isMobile,
      range,
      bindItem,
      bindImage,
      bindTitle,
      bindLink,
    };
  },
});
</script>
<style lang="scss">
.homepage-slide {
  @include sm {
    width: 530px !important;
  }
}

.homepage-wrapper {
  @include sm {
    height: 415px !important;
  }
}

.swiper-active-pagination {
  background: #e94b4d;
  border: none;
  width: 20px !important;
  border-radius: 100px;
}
</style>
